<template>
  <picture class="responsive-picture product-tile__image product-tile__image--default">
    <img src="/Static/missingproduct.png" alt="" class="responsive-picture__image" />
  </picture>
</template>

<script setup lang="ts"></script>
